var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CChartPie',{attrs:{"datasets":_vm.datasets,"labels":['MS', 'SW', 'APP']}}),_c('CElementCover',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],attrs:{"opacity":0.9}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }